import { gql } from '@apollo/client'

export const getWaterDropDetailsQuery = gql`
  query GetWaterDropDetails {
    me {
      id
      reader {
        id
        forest {
          id
          coins
          waterDropDetails {
            currentDrops
            dropsPerLevel
            maxDrops
            minimumLevel
            image
            percentage
            statusText
            description
          }
        }
      }
    }
  }
`

export const hasForestQuery = gql`
  query HasForest {
    me {
      id
      reader {
        id
        forest {
          id
          treeListings(count: 1) {
            id
          }
        }
      }
    }
  }
`
